import { render, staticRenderFns } from "./app_version_page.vue?vue&type=template&id=326fbb97&scoped=true"
import script from "./app_version_page.vue?vue&type=script&lang=js"
export * from "./app_version_page.vue?vue&type=script&lang=js"
import style0 from "./app_version_page.vue?vue&type=style&index=0&id=326fbb97&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326fbb97",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('326fbb97')) {
      api.createRecord('326fbb97', component.options)
    } else {
      api.reload('326fbb97', component.options)
    }
    module.hot.accept("./app_version_page.vue?vue&type=template&id=326fbb97&scoped=true", function () {
      api.rerender('326fbb97', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mng/app_version_page.vue"
export default component.exports